import { Wrench, Wifi, Mail, Printer, MonitorDown, ShieldAlert, HardDrive, Briefcase } from "lucide-react";
import { SERVICES } from "../../data/site";

const ICONS = {
    wrench: Wrench,
    wifi: Wifi,
    mail: Mail,
    printer: Printer,
    monitor: MonitorDown,
    shield: ShieldAlert,
    harddrive: HardDrive,
    briefcase: Briefcase,
};

export const Services = () => (
    <section id="services" data-testid="services-section" className="bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 md:py-16">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0F2E52] mb-2">
                Computer Services in Semaphore
            </h2>
            <p className="text-base md:text-lg text-slate-700 mb-8 max-w-3xl">
                From slow laptops to tricky Wi-Fi — help with everyday computer and technology problems, at your place.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {SERVICES.map((service) => {
                    const Icon = ICONS[service.icon];
                    return (
                        <article
                            key={service.title}
                            data-testid={`service-card-${service.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow flex flex-col items-start gap-3"
                        >
                            <span className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                                <Icon className="w-5 h-5" strokeWidth={1.5} />
                            </span>
                            <h3 className="text-base font-medium text-[#0F2E52]">{service.title}</h3>
                            <p className="text-sm leading-relaxed text-slate-600">{service.description}</p>
                        </article>
                    );
                })}
            </div>
        </div>
    </section>
);
